import { render } from "./SelectLanguageComponent.vue?vue&type=template&id=2c554000"
import script from "./SelectLanguageComponent.vue?vue&type=script&lang=js"
export * from "./SelectLanguageComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__